<template>
  <div class="settings-block">
    <div
      v-if="title"
      class="settings-block-title"
    >
      {{ title }}
    </div>

    <div
      class="settings-block-items list"
      :class="{ 'sortable sortable-opposite sortable-enabled': isSortable }"
      @sortable:sort="emitSortableSort"
    >
      <ul>
        <slot />
      </ul>
    </div>
  </div>
</template>

<script setup>
// @ts-check

defineProps({
  /** The title of the block. */
  title: { type: String, default: null },

  /** Whether the block is sortable. */
  isSortable: { type: Boolean, default: false },
});

const emit = defineEmits(['sortable:sort']);

/**
 * Emits the `sortable:sort` event.
 *
 * @param {Event} event - The sortable sort event.
 * @returns {void}
 */
function emitSortableSort(event) {
  if (event && 'detail' in event) {
    emit('sortable:sort', event.detail);
  }
}
</script>

<style scoped lang="scss">
.settings-block {
  font-size: 14px;
  background-color: #fff;
}

.settings-block-title {
  color: #b1b1b1;
  margin-bottom: var(--f7-typography-margin);
}

.settings-block-items {
  &.list ul {
    padding: 0;

    &::before,
    &::after {
      content: none;
    }
  }
}
</style>
